// This hook now delegates to useOrg for org-scoped roles
import { useOrgRole, OrgRole } from "@/hooks/useOrg";

export type AppRole = "admin" | "operator" | "viewer";

export const useUserRole = () => {
  const { role, loading, isOwner, isAdmin, isOperator, isViewer } = useOrgRole();

  // Map org roles to legacy app roles for backward compatibility
  const roles: AppRole[] = [];
  if (role === "owner" || role === "admin") roles.push("admin");
  if (role === "owner" || role === "admin" || role === "operator") roles.push("operator");
  if (role) roles.push("viewer");

  const hasRole = (r: AppRole) => roles.includes(r);
  const hasAnyRole = (...check: AppRole[]) => check.some((r) => roles.includes(r));

  return { roles, loading, hasRole, hasAnyRole, isAdmin, isOperator, isViewer };
};
